{
  "pages": {
    "dashboard": {
      "greeting": {
        "morning": "早安",
        "afternoon": "午安",
        "evening": "晚安"
      },
      "header": {
        "fallbackUser": "使用者",
        "facility": "院區 {{id}}"
      },
      "criticalBanner": {
        "message_one": "有 {{count}} 項重要檢驗結果需要確認",
        "message_other": "有 {{count}} 項重要檢驗結果需要確認",
        "reviewNow": "立即查看"
      },
      "sections": {
        "overview": "總覽",
        "tasks": "任務",
        "myPatients": "我的病人",
        "recentActivity": "近期動態",
        "quickActions": "快速操作"
      },
      "stats": {
        "activeEncounters": "進行中的就診",
        "pendingOrders": "待處理醫囑",
        "resultsToReview": "待審閱結果",
        "criticalAlerts": "重要警示"
      },
      "tasks": {
        "unsignedNotes": "未簽署之病歷",
        "criticalResultsPending": "待處理之重要結果",
        "cosignaturesNeeded": "需要會簽",
        "ordersToReview": "待審核醫囑",
        "activeMedications": "進行中之用藥",
        "admissionsPending": "待入院",
        "ordersToVerify": "待藥師核對之醫囑",
        "controlledSubstanceReviews": "管制藥品複核",
        "systemAlerts": "系統警示",
        "systemStatus": "系統狀態"
      },
      "systemStatusValue": {
        "healthy": "正常"
      },
      "empty": {
        "noPatients": "尚未指派負責的病人。",
        "noTasks": "目前沒有符合您角色的任務。",
        "noRecentEncounters": "尚無近期就診紀錄。"
      },
      "quickActions": {
        "findPatient": {
          "label": "搜尋病人",
          "description": "搜尋病歷"
        },
        "registerPatient": {
          "label": "登錄病人",
          "description": "新增病人"
        },
        "viewCensus": {
          "label": "查看住院人數",
          "description": "進行中的就診"
        },
        "reports": {
          "label": "報表",
          "description": "查看分析"
        }
      },
      "viewAll": "查看全部",
      "bedLabel": "床位 {{n}}",
      "admittedLabel": "入院 {{date}}",
      "fallback": {
        "unknownPatient": "未知病人",
        "unknownType": "未知"
      },
      "acuity": {
        "1": "急救",
        "2": "緊急",
        "3": "次緊急",
        "4": "較和緩",
        "5": "非緊急"
      },
      "encounterType": {
        "emergency": "急診",
        "inpatient": "住院",
        "outpatient": "門診",
        "observation": "留觀"
      },
      "encounterStatus": {
        "active": "進行中",
        "completed": "已完成",
        "discharged": "已出院",
        "cancelled": "已取消",
        "pending": "待處理"
      }
    },
    "qualityMeasures": {
      "title": "品質指標",
      "subtitle": "追蹤臨床品質指標與法規遵循情況",
      "refresh": "重新整理",
      "allTypesLabel": "全部類型",
      "allFacilitiesLabel": "全部機構",
      "targetPrefix": "目標:{{value}} {{unit}}",
      "updatedPrefix": "更新於:{{value}}",
      "measureType": {
        "process": "流程",
        "outcome": "結果",
        "structure": "結構"
      },
      "summary": {
        "totalMeasures": "指標總數",
        "meetingTarget": "達成目標",
        "belowTarget": "未達目標"
      },
      "toasts": {
        "refreshSuccess": "指標已重新整理"
      },
      "results": {
        "title": "已記錄結果",
        "period": "報告期",
        "facility": "機構",
        "denominator": "分母",
        "numerator": "分子",
        "exclusions": "排除",
        "rate": "比率",
        "source": "來源",
        "calculated": "計算時間",
        "empty": "本期該指標暫無已記錄結果。",
        "loadError": "無法載入已記錄結果。",
        "allFacilities": "全部機構",
        "record": "記錄結果"
      },
      "sources": {
        "manual": "手工",
        "sql-template": "SQL 範本",
        "import": "匯入"
      },
      "qrda": {
        "download": "QRDA III",
        "measureDownload": "QRDA",
        "success": "QRDA 報告已下載",
        "error": "QRDA 下載失敗"
      },
      "record": {
        "title": "記錄品質結果",
        "titleFor": "記錄結果 — {{code}} {{name}}",
        "subtitle": "已記錄的結果會顯示在指標歷史中，並納入 QRDA III 類匯出。重新記錄同一報告期將取代原有行。",
        "back": "返回品質指標",
        "cancel": "取消",
        "save": "記錄結果",
        "measureNotFound": "找不到指標。該指標可能已停用。",
        "fields": {
          "periodStart": "報告期開始",
          "periodEnd": "報告期結束",
          "facility": "機構",
          "allFacilities": "全部機構",
          "denominator": "分母",
          "numerator": "分子",
          "exclusions": "排除",
          "source": "計算來源",
          "completeness": "數據完整度",
          "completenessHint": "數據完整的合格記錄佔比，0 到 1。如不明請留空。",
          "notes": "備註"
        },
        "errors": {
          "periodStartRequired": "報告期開始為必填項",
          "periodEndRequired": "報告期結束為必填項",
          "periodOrder": "報告期結束不得早於報告期開始",
          "countInvalid": "請輸入 0 或更大的整數",
          "numeratorExceeds": "分子不得超過分母",
          "numeratorExceedsNet": "分子不得超過分母減去排除數",
          "sourceRequired": "計算來源為必填項",
          "completenessRange": "完整度須介於 0 到 1 之間"
        },
        "toast": {
          "success": "結果已記錄",
          "error": "記錄失敗"
        }
      }
    },
    "analyticsDashboard": {
      "title": "分析儀表板",
      "subtitle": "醫院營運指標與趨勢",
      "refresh": "重新整理",
      "changeVsPrevPeriod": "{{sign}}{{value}}% 較上期",
      "dateRange": {
        "today": "今日",
        "7d": "近7天",
        "30d": "近30天",
        "90d": "近90天"
      },
      "facility": {
        "all": "全部機構",
        "sgh": "SGH - 新加坡中央醫院",
        "nuh": "NUH - 新加坡國立大學醫院",
        "ttsh": "TTSH - 陳篤生醫院"
      },
      "department": {
        "all": "全部科室",
        "er": "急診科",
        "icu": "加護病房",
        "medsurg": "內外科",
        "peds": "兒科",
        "maternity": "產科"
      },
      "widget": {
        "census": {
          "title": "目前在院人數"
        },
        "bedOccupancy": {
          "title": "病床佔床率"
        },
        "avgLOS": {
          "title": "平均住院日"
        },
        "throughput": {
          "title": "就診總數"
        },
        "readmission": {
          "title": "待處理醫囑"
        }
      },
      "unit": {
        "patients": "位病人",
        "days": "天",
        "encounters": "次就診",
        "orders": "筆醫囑"
      },
      "charts": {
        "admissionsVsDischarges": "入院與出院",
        "admissionsByDepartment": "依科別入院數",
        "encounterTypes": "就診類型",
        "censusTrend": "在院人數趨勢",
        "insufficientData": "圖表資料不足",
        "insufficientTrendData": "趨勢圖資料不足"
      },
      "series": {
        "admissions": "入院",
        "discharges": "出院",
        "census": "在院人數"
      },
      "toasts": {
        "refreshSuccess": "儀表板已重新整理"
      }
    },
    "reportRunner": {
      "title": "報表執行",
      "subtitle": "產生並匯出臨床、財務及營運報表",
      "scheduleButton": "排程報表",
      "searchPlaceholder": "搜尋報表...",
      "allCategoriesLabel": "所有報表",
      "category": {
        "clinical": "臨床",
        "financial": "財務",
        "operational": "營運",
        "quality": "品質"
      },
      "emptyState": {
        "title": "請選擇一份報表開始",
        "subtitle": "請從左側報表清單中選擇"
      },
      "noResults": "沒有符合篩選條件的報表",
      "parametersHeading": "參數",
      "selectOptionPlaceholder": "請選擇...",
      "runButton": "執行報表",
      "runningReport": "正在執行報表...",
      "exportCsv": "CSV",
      "exportPdf": "PDF",
      "format": {
        "csv": "CSV",
        "pdf": "PDF"
      },
      "columnLabel": {
        "facilityLocalDate": "日期(院所當地時間)",
        "facilityTimeZone": "院所時區",
        "encounterDate": "日期(UTC)"
      },
      "resultSummary": {
        "rows": "共 {{total}} 列,顯示 {{shown}} 列",
        "executed": "執行耗時 {{ms}} 毫秒"
      },
      "toasts": {
        "success": "報表已完成,耗時 {{executionTimeMs}} 毫秒,共 {{rowCount}} 列",
        "failed": "報表執行失敗",
        "missingFields": "請填寫必填欄位:{{missingFields}}",
        "exporting": "正在匯出為 {{format}}...(預留位置)",
        "scheduledPlaceholder": "排程報表設定(預留位置)"
      }
    }
  }
}
